module.exports = __webpack_public_path__ + "media/images/play_button-9af401ee84a242c74c9ffb0312a22200.svg";